import React, { useContext, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { apiPost } from "../utils/api";
import { useNotify } from "../components/NotificationComponent";
import { UserContext } from "../context/UserContext";
import { fetchAccountInfo } from "../utils/commonAPI";

export default function LoginPage() {
    const { userInfo, setUserInfo, setUserMetaInfo } = useContext(UserContext)
    const [data, setData] = useState({
      username:"",
      password:""
    })
    const { notify } = useNotify()
    const navigate = useNavigate()

    useEffect(()=>{
      if(userInfo?.access){
        navigate('/')
      }
    },[userInfo])

    const loginHandler = async (e) => {
      e.preventDefault()
      for(let key of Object.keys(data)){
        if(data[key].length === 0){
          return notify('All fields are required.')
        }
      }
      apiPost('login/', data).then(res => {
          localStorage.setItem('userInfo', JSON.stringify(res))
          setUserInfo(res)
          fetchAccountInfo().then(res => {
            setUserMetaInfo(res)
            navigate('/')
          }).catch(err => {
            return notify(err.response && err.response.data.detail ? err.response.data.detail : err.message)
          })
          
      }).catch(err => {
        return notify(err.response && err.response.data.detail ? err.response.data.detail : err.message)
      })
    }
   
    return (
      <div className="bg-gray-50 min-h-screen font-sans px-5 py-10">
  
        <motion.section
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="p-6 md:p-16 text-center"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gray-800">
            Welcome Back
          </h2>
          <p className="text-gray-600 text-base md:text-lg max-w-xl mx-auto">
            Log in to access your dashboard, connect ad accounts, and start optimizing.
          </p>
        </motion.section>
  
        <motion.section
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="py-12 px-4 md:px-16"
        >
          <div className="max-w-md mx-auto bg-white p-8 rounded-xl shadow-md">
            <form className="space-y-6">
              <div>
                <label className="block mb-1 font-medium text-gray-700">Email</label>
                <input required value={data.username} onChange={(e)=>setData({...data, username:e.target.value})} type="email" placeholder="you@example.com" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
              </div>
              <div>
                <label className="block mb-1 font-medium text-gray-700">Password</label>
                <input required value={data.password} onChange={(e)=>setData({...data, password:e.target.value})} type="password" placeholder="••••••••" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
              </div>
              <p className="-mb-3 text-sm text-gray-500 text-end">Forgot password? <span className="text-blue-600 cursor-pointer hover:underline">Reset</span></p>
              <button onClick={(e)=>loginHandler(e)} type="submit" className="w-full bg-blue-600 text-white py-2 rounded-md font-semibold hover:bg-blue-700 transition">
                Log In
              </button>
              <p className="text-sm text-gray-500 text-center">New user? <span onClick={()=>navigate('/register')} className="text-blue-600 cursor-pointer hover:underline">Register</span></p>
            </form>
          </div>
        </motion.section>
  
      </div>
    );
  }